import React, { useState } from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, LegacyForm, Select } from "@payping/web-components";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import location from "@/assets/location.json";
import { DashboardChecksTypeEnum } from "@payping/api";
import { useHandleNavigationURL, useSaveToRedux } from "../utils";
import { useAtom } from "jotai";
import { settingsBusinessAtom } from "../../state";
import { selectAtom } from "jotai/utils";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const { Option } = Select;
interface CityType {
  cityName: string;
  cityId: number;
}
const MobileEditBusinessCity: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const { t } = useAppTranslation();
  const [form] = LegacyForm.useForm();
  const isLocalDisabled = useAppSelector(
    (state) => state.user.checks?.localStatus === DashboardChecksTypeEnum.Confirmed,
  );
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const cityApi = useAppSelector((state) => state.user.localInfo?.city);
  // State
  const stateIdApi = useAppSelector((state) => state.user.localInfo?.stateId);

  const stateData = location.find(({ stateId }) => stateId === mobileFormEditState.stateId || stateId === stateIdApi);
  const cities: CityType[] = stateData?.cities || [];

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        placement={"bottom"}
        height={"100%"}
        title={`${t("edit")} / ${t("city")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <LegacyForm
          onFinish={({ city }) =>
            saveToRedux({
              nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.address.url,
              fieldName: "city",
              fieldValue: city,
              setIsDrawerOpen,
            })
          }
          form={form}
          initialValues={{
            city:
              mobileFormEditState.city ??
              (mobileFormEditState.stateId && mobileFormEditState.stateId === stateIdApi ? cityApi : undefined),
          }}
        >
          <LegacyForm.Item label={t("city")} name="city">
            <Select disabled={isLocalDisabled}>
              {cities?.map(({ cityId, cityName }) => (
                <Option value={cityName} key={cityId}>
                  {cityName}
                </Option>
              ))}
            </Select>
          </LegacyForm.Item>
        </LegacyForm>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditBusinessCity;
